module.exports = __webpack_public_path__ + "img/19.42e297d7.svg";